import React from "react";
import { BoardPage } from "./board-page";
import { BoardProjectHubResolver } from "./board-project-hub";
import { BoardProjectsIndexInner } from "./board-projects-index";
import { IssueFullPageInner } from "./issue-full-page";

export interface BoardRouteDef {
  path: string;
  element: React.ReactNode;
}

// The board pages the in-designer board overlay mounts under its own MemoryRouter, so browsing the
// board never changes the designer's URL. These are the SAME pages the app router serves under
// /board, minus the `withManagement` shell — that shell reads document.location and runs workspace
// queries, neither of which belongs inside the overlay. Mirror any board-route change here and in
// routes/router.tsx.
export const BOARD_OVERLAY_ROUTE_DEFS: BoardRouteDef[] = [
  { path: "/:domainName/board", element: <BoardProjectsIndexInner /> },
  { path: "/:domainName/board/multi/:boardSlug", element: <BoardPage /> },
  { path: "/:domainName/board/multi/:boardSlug/:issueKey", element: <BoardPage /> },
  { path: "/:domainName/board/:projectKey", element: <BoardProjectHubResolver /> },
  { path: "/:domainName/board/:projectKey/:boardSlug", element: <BoardPage /> },
  { path: "/:domainName/board/:projectKey/:boardSlug/:issueKey", element: <BoardPage /> },
  { path: "/:domainName/issue/:issueKey", element: <IssueFullPageInner /> }
];
